import React from 'react';
import { Modal, Typography } from 'antd';
import { useLocation } from 'react-router-dom';
import { usePaymentProfile } from '../context/payment-profile';
import { PaymentDataForm } from './payment-data-form';

/**
 * Popup "Completa tus datos personales": si al usuario logueado le faltan sus datos
 * OBLIGATORIOS (nombre + email válido + términos aceptados + mayoría de edad →
 * `complete` del backend), se abre en el Home apenas entra.
 *
 * 🔒 BLOQUEO DURO (feedback 2026-07-13): mientras falte alguno de los 4, el modal NO se puede
 * cerrar de ninguna forma — sin cruz, sin Escape, sin click afuera, sin botón Cancelar. La
 * única salida es completar los 4 y tocar "Aceptar" (que guarda). Los datos de COBRO (país,
 * Mercado Pago o transferencia) NO van en el popup (feedback 2026-07-30): se cargan desde
 * Settings y su ausencia dispara el ⚠️ de "faltan datos para el pago", no este bloqueo.
 * Al quedar completo, el popup se cierra solo. Se monta dentro de PaymentProfileProvider.
 */
export const PaymentDataGate: React.FC = () => {
  const { profile, loading, complete } = usePaymentProfile();
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '';
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    // Abrir en Home si faltan datos obligatorios; cerrar apenas el perfil quede completo.
    if (complete) setOpen(false);
    else if (isHome && !loading && profile) setOpen(true);
  }, [isHome, loading, profile, complete]);

  return (
    <Modal
      title='Completa tus datos personales'
      open={open}
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      destroyOnClose
    >
      <Typography.Text type='secondary' style={{ display: 'block', marginBottom: 14 }}>
        Necesitamos estos datos para poder pagarte tus premios. El <strong>nombre</strong>, el{' '}
        <strong>email</strong>, la aceptación de los términos y confirmar que sos{' '}
        <strong>mayor de edad</strong> son obligatorios para usar la app.
      </Typography.Text>
      <PaymentDataForm
        submitLabel='Aceptar'
        emailLabel='Email'
        onSaved={() => setOpen(false)}
      />
    </Modal>
  );
};
